module.exports = __webpack_public_path__ + "img/logo.83fd783b.svg";